import { t } from 'i18next';
import { useLogicBlocks } from '@morph-mapper/node-logic';
import { useStore } from '@/store';
import { useGraphContext } from '../../context/graph/hook';
import { GraphRefType } from '../../types/graph';

export const useGraphBreadcrumbTitles = () => {
  const [variant, IGraph, getGraphRef] = useStore(
    ({ config: c, graphs: g }) => [c.getVariant(), g.graph, g.getRef]
  );
  const graphId = useGraphContext(({ graph: g }) => g.getId());
  const { logicBlocks } = useLogicBlocks(variant);
  const nodeTitles: string[] = [];
  let currentGraphId = graphId;

  let currentRef = getGraphRef(currentGraphId);

  while (currentRef.kind === GraphRefType.Param) {
    const parentNodes = IGraph(currentRef.graphId).getNodes();
    const ownerNode = parentNodes[currentRef.ownerNodeId];

    if (ownerNode) {
      nodeTitles.push(t(logicBlocks[ownerNode.kind].title));
    }

    currentGraphId = currentRef.graphId;
    currentRef = getGraphRef(currentGraphId);
  }

  return nodeTitles.reverse();
};
